import { createReducer, on } from '@ngrx/store';
import * as UIActions from './ui.actions';

export interface UIState {
  searchQuery: string;
  isOnline: boolean;
  selectedTab: string;
  loadingKeys: Record<string, boolean>;
}

export const initialUIState: UIState = {
  searchQuery: '',
  isOnline: true,
  selectedTab: 'home',
  loadingKeys: {}
};

export const uiReducer = createReducer(
  initialUIState,

  on(UIActions.setSearchQuery, (state, { query }) => ({ ...state, searchQuery: query })),
  on(UIActions.setNetworkStatus, (state, { isOnline }) => ({ ...state, isOnline })),
  on(UIActions.setSelectedTab, (state, { tab }) => ({ ...state, selectedTab: tab })),
  on(UIActions.setLoading, (state, { key, loading }) => ({
    ...state,
    loadingKeys: { ...state.loadingKeys, [key]: loading }
  }))
);
